<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 18 22"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M10 0c.043 0 .085.003.126.008L10 0c.053 0 .105.004.157.012.031.005.062.012.093.02l.03.008c.03.009.061.02.091.031l.027.012c.028.012.056.025.082.04l.032.018c.028.016.055.035.081.054l.02.015.012.01.082.073 7 7c.03.03.057.06.082.093l-.082-.093c.036.036.069.074.098.114.02.026.038.053.054.081l.018.032c.015.026.028.054.04.082l.012.027c.012.03.022.06.031.091l.008.03c.008.03.015.062.02.093l.004.031c.005.041.008.083.008.126v11c0 1.657-1.343 3-3 3H3c-1.657 0-3-1.343-3-3V3c0-1.657 1.343-3 3-3zM9 2H3c-.552 0-1 .448-1 1v16c0 .552.448 1 1 1h12c.552 0 1-.448 1-1V9h-6c-.513 0-.936-.386-.993-.883L9 8V2zm5.586 5L11 3.415V7h3.586z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-document",
  components: {},
})
export class IconDocument extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconDocument;
</script>
